import { render, staticRenderFns } from "./DeliverTodo_new.vue?vue&type=template&id=925ab1b8&scoped=true"
import script from "./DeliverTodo_new.vue?vue&type=script&lang=js"
export * from "./DeliverTodo_new.vue?vue&type=script&lang=js"
import style0 from "./DeliverTodo_new.vue?vue&type=style&index=0&id=925ab1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925ab1b8",
  null
  
)

export default component.exports